module.exports = __webpack_public_path__ + "img/sustainability-widget-mobile.79521a26.jpg";